import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"

import {
	ErrorConfig, ErrorResponse,
	ErrorService, ErrorType, RestResponse,
} from "@sinossi/mates-react-library"

export class StorebookErrorService extends ErrorService
{
	private static STOREBOOK_INSTANCE: StorebookErrorService|null = null

	public static defaultErrorConfig: ErrorConfig = {
		showErrorCode: false,
		options: {
			showErrorTimestamp: true,
			timestampFormat: "dd/MM/yyyy - HH:mm:ss.SSS",
			showCancel: false,
			okText: "OK",
			cancelText: "",
		},
	}


	private readonly GENERIC_ERROR: string = /*i18n*/i18n._("errors.generic_message")

	errorList: Record<number, string> = {
		0: t({ id: "errors.cannot_contact_server", message: "Server irraggiungibile. Si prega di riprovare." }), // Server irraggiungibile
		0x1000: t({ id: "errors.generic_message", message: "È avvenuto un errore imprevisto. Si prega di riprovare." }), // GENERIC_ERROR
		0x1010: t({ id: "errors.state_machine", message: "Impossibile aggiornare lo stato dell'oggetto selezionato." }), // STATE_MACHINE_ERROR
		0x1030: this.GENERIC_ERROR, // REQUEST_ERROR

		0x1100: this.GENERIC_ERROR, // PAGINATION_PAGE_NEGATIVE
		0x1101: this.GENERIC_ERROR, // PAGINATION_LIMIT_NEGATIVE
		0x1102: this.GENERIC_ERROR, // PAGINATION_LIMIT_TOO_BIG

		0x1200: this.GENERIC_ERROR, // CONFIGURATION_LOAD_ERROR
		0x1210: this.GENERIC_ERROR, // CONFIGURATION_DIRECTORY_NOT_FOUND
		0x1220: this.GENERIC_ERROR, // CONFIGURATION_FILE_NOT_FOUND

		0x3000: t({ id: "errors.company_not_found", message: "La Società non è stata trovata" }), // COMPANY_NOT_FOUND
		0x3100: t({ id: "errors.brand_not_found", message: "Il Brand non è stato trovato" }), // BRAND_NOT_FOUND
		0x3110: t({ id: "errors.brand_representative_not_found", message: "Il rappresentante del Brand non è stato trovato" }), // BRAND_REPRESENTATIVE_NOT_FOUND
		0x3120: this.GENERIC_ERROR, // BRAND_REQUISITE_NOT_FOUND
		0x3130: this.GENERIC_ERROR, // BRAND_PRIORITY_NOT_FOUND

		0x4000: t({ id: "errors.asset_not_found", message: "L'immobile non è stato trovato" }), // ASSET_NOT_FOUND
		0x4100: t({ id: "errors.match_not_found", message: "Il match non è stato trovato" }), // MATCH_NOT_FOUND

		0x5000: t({ id: "errors.landlord_not_found", message: "Il Landlord non è stato trovato" }), // LANDLORD_NOT_FOUND

		0x6000: t({ id: "errors.document_not_found", message: "Il documento non è stato trovato" }), // DOCUMENT_NOT_FOUND
		0x6010: t({ id: "errors.document_read_error", message: "Impossibile leggere il documento" }), // DOCUMENT_READ_ERROR
		0x6011: t({ id: "errors.document_write_error", message: "Impossibile salvare il documento" }), // DOCUMENT_WRITE_ERROR
	}
	redirectErrorList: Record<number, string> = {
		0x2000: "/forbidden",  // ACCOUNT_NOT_FOUND
	}
	callbackErrorList: number[] = [
		0x1020, // VALIDATION_ERROR
		0x2000, // USER_NOT_FOUND
	]

	private constructor()
	{
		super()
	}

	public getErrorType = (response?: RestResponse<any, ErrorResponse>|null): ErrorType => {
		const code: number = ErrorService.getErrorCode(response)
		if(code != 418 && code >= 400 && code <= 599) { // Errors not generated by backend logic
			return ErrorType.HTTP_ERROR
		}

		if(code in this.errorList) {
			return ErrorType.MESSAGE
		}
		if(code in this.redirectErrorList) {
			return ErrorType.REDIRECT
		}
		if(this.callbackErrorList.includes(code)) {
			return ErrorType.CALLBACK
		}

		return ErrorType.UNKNOWN
	}

	public static init(): StorebookErrorService
	{
		if(StorebookErrorService.STOREBOOK_INSTANCE === null) {
			StorebookErrorService.STOREBOOK_INSTANCE = new StorebookErrorService()
		}

		return StorebookErrorService.STOREBOOK_INSTANCE!
	}

	protected getRestErrorDialogTitle = (code: number): string => {
		return /*i18n*/i18n._("errors.modal_title")
	}

	protected getGenericErrorMessage = (): string => {
		return this.GENERIC_ERROR
	}
}
